import { useEffect, useMemo, useState } from "react";

import logo from "../images/logo.webp";
import "../css/ComingSoon.css";

const getTimeRemaining = (launchTime) => {
  const total = Math.max(launchTime - Date.now(), 0);

  return {
    total,
    days: Math.floor(total / (1000 * 60 * 60 * 24)),
    hours: Math.floor((total / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((total / (1000 * 60)) % 60),
    seconds: Math.floor((total / 1000) % 60),
  };
};

const CountdownItem = ({ value, label }) => (
  <div className="coming-soon-countdown-item">
    <strong>{String(value).padStart(2, "0")}</strong>
    <span>{label}</span>
  </div>
);

const ComingSoon = ({ launchDate, onLaunch }) => {
  const launchTime = useMemo(
    () => new Date(launchDate).getTime(),
    [launchDate]
  );
  const [timeRemaining, setTimeRemaining] = useState(() =>
    getTimeRemaining(launchTime)
  );

  useEffect(() => {
    const updateCountdown = () => {
      const nextTimeRemaining = getTimeRemaining(launchTime);

      setTimeRemaining(nextTimeRemaining);

      if (nextTimeRemaining.total === 0) {
        onLaunch();
      }
    };

    updateCountdown();
    const timer = window.setInterval(updateCountdown, 1000);

    return () => window.clearInterval(timer);
  }, [launchTime, onLaunch]);

  return (
    <main className="coming-soon-page">
      <div className="coming-soon-orbit coming-soon-orbit-one" />
      <div className="coming-soon-orbit coming-soon-orbit-two" />

      <span className="coming-soon-leaf coming-soon-leaf-top" />
      <span className="coming-soon-leaf coming-soon-leaf-bottom" />

      <section className="coming-soon-card">
        <div className="coming-soon-logo-wrap">
          <img
            src={logo}
            alt="Wedding Stationery"
            className="coming-soon-logo"
          />
        </div>

        <p className="coming-soon-eyebrow">
          A new chapter begins
        </p>

        <h1>Something beautiful is on its way.</h1>

        <div className="coming-soon-divider" aria-hidden="true">
          <span />
          <i />
          <span />
        </div>

        <p className="coming-soon-intro">
          A thoughtfully curated collection of elegant wedding
          stationery, designed to make every celebration feel
          unmistakably yours.
        </p>

        <div
          className="coming-soon-countdown"
          role="timer"
          aria-label={`${timeRemaining.days} days, ${timeRemaining.hours} hours, ${timeRemaining.minutes} minutes and ${timeRemaining.seconds} seconds until launch`}
        >
          <CountdownItem value={timeRemaining.days} label="Days" />
          <CountdownItem value={timeRemaining.hours} label="Hours" />
          <CountdownItem value={timeRemaining.minutes} label="Minutes" />
          <CountdownItem value={timeRemaining.seconds} label="Seconds" />
        </div>

        <p className="coming-soon-date">
          <span>Launching</span>
          01 October 2026
        </p>

        <a
          className="coming-soon-contact"
          href="mailto:contact@grapheweddings.com"
        >
          contact@grapheweddings.com
        </a>
      </section>

      <p className="coming-soon-note">
        Made with care for celebrations that last a lifetime.
      </p>
    </main>
  );
};

export default ComingSoon;
